<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel d-flex flex-column w-70pc">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{ panelHeading }}</h2>
            </div>            
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning mr-2" (click)="fnShowConfigureshowLoggingAlertPanel()">
                    {{ 'label_log' | translate }}
                </button>
                <button type="button" class="btn eod-btn-primary mr-2"[ngClass]="{'disabled': disableSave }" (click)="saveAssignedGradeToCategoriesByGrade()">
                    {{ 'label_save' | translate }}
                </button>
                <button type="button" class="btn eod-btn-outline-warning" (click)="fnClosePanel()">
                    {{ 'label_close' | translate }}
                </button>
            </div>
        </header>
        <div class="block mt-2 heightCalc-5">
            <div class="heightCalc-12">
                <!----------------------Start Grid--------------------------->
                <app-grid [columns]="gridColumnDefs" [data]="gridData" [gridConfigItems]="gridConfigItems"
                    [gridFilterItems]="gridFilterItems" (filterChanged)="fnGridFilterChanged($event)"
                    (onCellClick)="fnOnGridCellClick($event)" (onCheckAll)="fnOnGridCheckAll($event)">
                </app-grid>
                <!----------------------End Grid--------------------------->
            </div>
        </div>
    </div>
</div>
<div id="rightSideBar">
    <div class="rightSidePanel" [ngClass]="{ active: showNoCategorySelected==true }">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{ "label_alert" | translate }}</h2>
            </div>            
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning" (click)="closeNoCategorySelected()">
                    {{ 'label_close' | translate }}
                </button>
            </div>
        </header>
        <div class="block">
            <h6 class="info-text">
                <i class="fas fa-info-circle"></i>
                <span>{{ "no_category_selected_grade" | translate }}</span>
            </h6>
        </div>
    </div>
</div>